import styled from 'styled-components';
import ds from 'designsystem';

const DebugOptionInput = styled.input`
  cursor: pointer;
  margin-left: ${ds.get('metrics.xs')};
`;

export default DebugOptionInput;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionInput.jsx